import { useLazyVerifySerialNumberQuery } from '@api/warranty.api';

export const useSerialNumber = () => {
  const [verifySerialNoRequest, verifySerialNoResponse] = useLazyVerifySerialNumberQuery();
  const { status: serialNoStatus } = verifySerialNoResponse;

  const sanitizeSerialNo = (input?: string) => input?.replace(/[^a-zA-Z0-9]/g, '');
  return {
    verifySerialNoRequest,
    verifySerialNoResponse,
    serialNoStatus,
    sanitizeSerialNo,
  };
};
